import axios from "../../config/axiosConfig";
import {
  GSTR9_REPORT_REQUEST,
  GSTR9_REPORT_SUCCESS,
  GSTR9_REPORT_FAILURE,
} from "../types/gstr9-report-types";

export const getGSTR9Report = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GSTR9_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
    
      const requestParams = { ...defaultParams, ...params };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/gstr9-report/getReport?${queryString}`;
      console.log('Complete GSTR9 API Request URL: ', fullUrl);
      return axios.get('/gstr9-report/getReport', { params: requestParams }).then((response) => {
        if (response) {
          dispatch({ 
            type: GSTR9_REPORT_SUCCESS, 
            payload: response 
          });
          console.log("Actions Api Call" , response);
          
          return response;
        } else {
          throw new Error(response.data?.message || 'Failed to fetch GSTR2 report');
        }
      }).catch((error) => {
        console.error("Error fetching GSTR9 Report:", error);
        dispatch({ 
          type: GSTR9_REPORT_FAILURE, 
          error: error.response?.data?.message || error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GSTR9 Report:", error);
      dispatch({ 
        type: GSTR9_REPORT_FAILURE, 
        error: error.response?.data?.message || error.message 
      });
      throw error;
    }
  };
};
